import React from 'react';
import ReactDOM from 'react-dom';
import { ZoomSlider } from './ZoomSlider';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.Portti2Zoombar
 * Zoombar implementation with jQuery UI and refined graphics. Location can be configured,
 * but defaults on top of the map with placement details on the css-file.
 *
 * See http://www.oskari.org/trac/wiki/DocumentationBundleMapModulePluginPorttiZoombar
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.Portti2Zoombar',
/**
 * @static @method create called automatically on construction
 *
 *
 */
function (config) {
  // hackhack for old configs so we don't have to remove
  // with-panbuttons from them
  this._config = config;
  if (config && config.location && config.location.classes) {
    config.location.classes = config.location.classes.replace('with-panbuttons', '');
    this._config = config;
  }
  this._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.Portti2Zoombar';
  this._defaultLocation = 'top right';
  this._index = 30;
  this._name = 'Portti2Zoombar';
  this._suppressEvents = false;
}, {
  /**
   * @private @method _createControlElement
   * Draws the zoombar on the screen.
   *
   * @return {jQuery}
   * Plugin jQuery element
   */
  _createControlElement: function _createControlElement() {
    return jQuery('<div class="oskariui mapplugin pzbDiv zoombar"></div>');
  },
  /**
   * @public  @method _refresh
   * Called after a configuration change.
   */
  refresh: function refresh() {
    var _this = this;
    var el = this.getElement();
    if (!el) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(ZoomSlider, {
      changeZoom: function changeZoom(value) {
        return _this.getMapModule().setZoomLevel(value);
      },
      zoom: this.getMapModule().getMapZoom(),
      maxZoom: this.getMapModule().getMaxZoomLevel(),
      isMobile: Oskari.util.isMobile()
    }), el[0]);
  },
  /**
   * @method _createEventHandlers
   * Create eventhandlers.
   *
   * @return {Object.<string, Function>} EventHandlers
   */
  _createEventHandlers: function _createEventHandlers() {
    var me = this;
    return {
      AfterMapMoveEvent: function AfterMapMoveEvent() {
        me.refresh();
      }
    };
  },
  teardownUI: function teardownUI() {
    this.removeFromPluginContainer(this.getElement());
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public createPluginUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    if (!this.isVisible()) {
      // no point in drawing the ui if we are not visible
      return;
    }
    var me = this;
    this.teardownUI();
    me._element = me._createControlElement();
    this.refresh();
    this.addToPluginContainer(me._element);
  },
  /**
   * @method _stopPluginImpl BasicMapModulePlugin method override
   * @param {Oskari.Sandbox} sandbox
   */
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});